// import moment from 'moment'
// import Cookies from 'js-cookie'



export default {
  state: () => ({
    submitData: JSON.parse(window.sessionStorage.getItem("submitData")) , 
    userInfo: JSON.parse(window.sessionStorage.getItem("userInfo")) , 
    faceInInfo: JSON.parse(window.sessionStorage.getItem("faceInInfo")) , 
    
  }),
  mutations: {
    SER_SUBMIT_DATA(state, submitData) {
      state.submitData = submitData
      if (!submitData) {
        window.sessionStorage.removeItem('submitData')
      } else {
        window.sessionStorage.setItem('submitData',  JSON.stringify(submitData), {})
      }
    },
    SER_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      if (!userInfo) {
        window.sessionStorage.removeItem('userInfo')
      } else {
        window.sessionStorage.setItem('userInfo',  JSON.stringify(userInfo), {})
      }
    },
    
    SER_FACE_IN_INFO(state, faceInInfo) {
      state.faceInInfo = faceInInfo
      if (!faceInInfo) {
        window.sessionStorage.removeItem('faceInInfo')
      } else {
        window.sessionStorage.setItem('faceInInfo',  JSON.stringify(faceInInfo), {})
      }
    },
    
  },
  actions: {
    async setsubmitData({ commit }, submitData) {
      commit('SER_SUBMIT_DATA', submitData)
    },
    async setUserInfo({ commit }, userInfo) {
      commit('SER_USER_INFO', userInfo)
    },
    async setFaceInInfo({ commit }, faceInInfo) {
      commit('SER_FACE_IN_INFO', faceInInfo)
    },
  }
}
